import DateModel from "../models/Date";
export default class DateService {
    mapInterfaceToModel(input, repositories = null) {
        let date = new DateModel();
        date.id = input.id;
        date.name = input.name;
        date.week = input.week;
        return date;
    }
    formatStartDate(startDate) {
        return new Date(startDate);
    }
    formatDateName(date) {
        return (date.getMonth() + 1).toString().padStart(2, "0") + "." + date.getDate().toString().padStart(2, "0");
    }
}
